export default {"src":"/_next/static/image/public/images/flags/flag_880.633f36707f334a16afac0a9156b11b50.svg","height":16,"width":25};